import React from 'react';
import { Typography } from '@mui/material';

type OrderStatusMessageProps = {
  message: any;
};

const OrderStatusMessage: React.FC<OrderStatusMessageProps> = ({ message }) => {
  return (
    <>
      <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }}>
        {message?.content?.body?.text || 'Order status update'}
      </Typography>
    </>
  );
};

export default OrderStatusMessage;
